<template>
  <b-col cols=12 lg=6 class='mb-5 pt-2'>
    <div class='card box pt-2 pb-4 mt-2'>
      <b-container>
        <h5 class="text-center txt-color-secondary pt-4 pb-4"> <b>Stake</b> Asset {{this.type ==='team' ? 'Team' : ''}}</h5>
        <b-form @submit.stop.prevent="onSubmit">
          <div class=''>
            <b-row>
                <b-col cols=12 class=''>
                    <b-form-group>
                        <div class="input-group m-0">
                            <b-col class="p-0 color-primary text-right" cols=12>
                                <h6 class="m-0">
                                    <span class="color-secondary text-right">Balance</span> {{this.GLOBAL._toDecimal(this.balance, 9)}} SGBT
                                </h6>
                            </b-col>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
              <b-col cols=12 class=''>
                  <b-form-group>
                      <b-input-group class='mb-2'>
                          <template #prepend>
                              <b-input-group-text class="btn btn-primary">
                                  <h6 class='mb-0' style='width: 35px;'><b>SGBT</b></h6>
                              </b-input-group-text>
                          </template>
                          <b-form-input
                              v-model="updateFormAmount"
                              :state="validateState($v.form.amount)"
                              :formatter="formatter_9"
                              :disabled = "Locked || this.aproved !== 0"
                              />
                          <b-form-invalid-feedback class="pl-2" :state="validateState($v.form.amount)">
                              {{getErrorMessage($v.form.amount)}}
                          </b-form-invalid-feedback>
                      </b-input-group>
                  </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="type==='users'" >
              <b-col cols=12>
                <b-form-group>
                  <div class="input-group box py-2">
                    <b-col class="p-0 color-secondary" cols=4><p class="m-0">Earn</p></b-col>
                    <b-col class="p-0 color-primary text-right" cols=8><h6 class="m-0">{{ this.GLOBAL._toDecimal(this.earn*Math.pow(10,9), 9) }} SGBT</h6></b-col>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols=12>
              <b-form-group>
                <div class="input-group box py-2">
                  <!---->
                  <b-col class="p-0 color-secondary" cols=4><p class="m-0">Percentage</p></b-col>
                  <b-col class="p-0 color-primary text-right" cols=8><h6 class="m-0">{{this.percentage}} %</h6></b-col>
                  <!---->
                  <b-col class="p-0 color-secondary" cols=4><p class="m-0">Time</p></b-col>
                  <b-col class="p-0 color-primary text-right" cols=8><h6 class="m-0">{{this.time}}</h6></b-col>
                  <!---->
                  <b-col class="p-0 color-secondary" cols=4><p class="m-0">Fee</p></b-col>
                  <b-col class="p-0 color-primary text-right" cols=8><h6 class="m-0">{{this.fee}} TRX</h6></b-col>
                </div>
              </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols=12 class='text-right mt-4'>
                <b-button
                  :disabled = "Locked || isLoggenIn"
                  class="btn-sm"
                  style='width: 160px;'
                  type="submit"
                  variant="primary"
                >{{btnTitle()}}</b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-container>
    </div>
  </b-col>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
  props: [
    'type',
    'balance',
    '_disabled',
    'aproved',
    'loggenIn',
    'min',
    '_max'
  ],
  data () {
    return {
      form: {
        amount: 0,
        min: 0,
        max: 0,
        title: 'approve'
      },
      earn: 0,
      percentage: 12,
      time: '365 Days',
      fee: '--',
      // balance: 1000000000000,
      errorMessages: {
        required: 'this amount is required.',
        minValue: ' MIN 0 SGB.',
        maxValue: ' MAX 1 SGB.'
      },
      Locked: false
    }
  },
  created () {
    this.form.min = this.min
    this.form.max = this._max
    this.errorMessages.minValue = ' MIN ' + this.formatter(this.form.min, 2) + ' SGB'
    this.errorMessages.maxValue = ' MAX ' + this.formatter(this.form.max, 2) + ' SGB'
  },
  computed: {
    updateFormAmount: {
      get: function () { return this.form.amount },
      set: function (amount) {
        this.form.amount = amount
        this.earn = this.getEarn(amount)
        this.$v.form.$touch()
      }
    },
    isLoggenIn () {
      return this._disabled
    }
  },
  watch: {
    aproved: function (newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      if (newVal === 0) {
        this.form.amount = 0
        this.form.title = 'approve'
      } else {
        this.form.title = 'stake'
        this.form.amount = newVal
        this.earn = this.getEarn(newVal)
      }
    },
    _disabled: function (newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.Locked = newVal
    },
    _max: function (newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.form.max = newVal
      this.errorMessages.maxValue = ' MAX ' + this.formatter(this.form.max, 2) + ' SGB'
    }
  },
  validations: {
    form: {
      amount: {
        required,
        minValue: function (value) {
          if (value === 0) {
            return false
          }
          return value >= this.min
        },
        maxValue: function (value) { return value <= this.form.max }
      }
    }
  },
  methods: {
    getEarn (amount) {
      return this.formatter(amount * this.percentage / 100, 9)
    },
    validateState (item) {
      const { $dirty, $error } = item
      return $dirty ? !$error : null
    },
    getErrorMessage (item) {
      if (item.$error) {
        for (const key in item.$params) {
          if (item[key] === false) {
            return this.errorMessages[key]
          }
        }
      }
      return null
    },
    formatter (value, max) {
      const split = value.toString().split('.')
      if (split.length === 2) {
        if (split[1].length > max) {
          const temp = split[0] + '.' + split[1].substring(0, max)
          return temp
        }
      }
      return value
    },
    formatter_9 (value) { return this.formatter(value, 9) },
    onSubmit () {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.$emit(
        'event', {
          title: this.form.title,
          amount: this.form.amount
        }
      )
      // this.form.amount = 0
    },
    btnTitle () { return this.form.title }
  }
}
</script>
